import { createStore } from 'vuex';

import createPersistedState from 'vuex-persistedstate';

import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';

export default createStore({
	state,
	getters,
	mutations,
	actions,
	plugins: [createPersistedState()],
	strict: process.env.NODE_ENV !== 'production',
});
